import React, { createContext, useState, useEffect } from 'react';
import { getFirestore, doc, setDoc, getDoc } from 'firebase/firestore';
import { auth } from '../firebase';

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([]);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      if (user) {
        fetchCart(user.uid);
      } else {
        setCartItems([]);
      }
    });

    return () => unsubscribe();
  }, []);

// Récupérer le panier de l'utilisateur depuis Firestore
const fetchCart = async () => {
  const user = auth.currentUser;
  if (user) {
    const db = getFirestore();
    const cartDoc = await getDoc(doc(db, 'carts', user.uid));
    
    if (cartDoc.exists()) {
      setCartItems(cartDoc.data().items);
    } else {
      console.log('Aucun panier trouvé pour cet utilisateur');
    }
  } else {
    console.log('Utilisateur non connecté');
  }
};


const addToCart = async (product) => {
  const updatedCart = [...cartItems];  // Copie de l'état actuel du panier
  const existingItem = updatedCart.find(item => item.id === product.id);

  // Si le produit est déjà dans le panier, on augmente la quantité
  if (existingItem) {
    existingItem.quantity += 1;
  } else {
    // Sinon, on ajoute le produit avec une quantité de 1
    updatedCart.push({ ...product, quantity: 1 });
  }

  // Met à jour l'état du panier localement
  setCartItems(updatedCart);

  // Vérifie si un utilisateur est connecté
  const user = auth.currentUser;
  if (user) {
    // Sauvegarde du panier dans Firestore
    try {
      const db = getFirestore();
      await setDoc(doc(db, 'carts', user.uid), {
        items: updatedCart,  // Le panier mis à jour
        userId: user.uid,    // L'ID de l'utilisateur connecté
        userName: user.email || 'Nom non défini',  // Le nom de l'utilisateur
      });

      console.log('Panier sauvegardé avec succès');
    } catch (error) {
      console.error('Erreur lors de la sauvegarde du panier :', error);
    }
  } else {
    console.log('Utilisateur non connecté');
  }
};


  const updateQuantity = async (id, delta) => {
    const updatedCart = cartItems.map(item => {
      if (item.id === id) {
        return { ...item, quantity: Math.max(1, item.quantity + delta) };
      }
      return item;
    });

    setCartItems(updatedCart);

    const db = getFirestore();
    const user = auth.currentUser;
    if (user) {
      await setDoc(doc(db, 'carts', user.uid), { items: updatedCart });
    }
  };

  const removeItem = async (id) => {
    const updatedCart = cartItems.filter(item => item.id !== id);
    setCartItems(updatedCart);

    const db = getFirestore();
    const user = auth.currentUser;
    if (user) {
      await setDoc(doc(db, 'carts', user.uid), { items: updatedCart });
    }
  };

  return (
    <CartContext.Provider value={{ cartItems, addToCart, updateQuantity, removeItem }}>
      {children}
    </CartContext.Provider>
  );
};
